<div class="settings-box">
  <div class="settings-box__header">
    <h2 class="settings-box__title">{{ content?.fields?.resources | findResource: 'settings.paymentMethodTitle' }}</h2>
    <a class="settings-box__edit" (click)="editPaymentMethod = !editPaymentMethod" *ngIf="!editPaymentMethod">{{
      content?.fields?.resources | findResource: 'settings.editLinkText'
    }}</a>
  </div>

  <div class="show-payment-method" *ngIf="!editPaymentMethod">
    <ng-container *ngIf="defaultPaymentMethod$ | async as paymentMethod">
      <span class="card-brand">{{ paymentMethod.card.brand }}</span>
      <span class="card-number">**** **** {{ paymentMethod.card.last4 }}</span>
      <span class="card-valid-until">
        {{ content?.fields?.resources | findResource: 'settings.validUntilText' }}
        {{ paymentMethod.card.exp_month }} / {{ paymentMethod.card.exp_year }}
      </span>
    </ng-container>
  </div>

  <div class="edit-payment-method overlay-wrapper" [ngClass]="{ 'edit-payment-method--hidden': !editPaymentMethod }">
    <div id="overlay" *ngIf="updatePaymentMethodProcessing"></div>
    <!--<div class="pad" *ngIf="(defaultPaymentMethod$ | async) as pm">
      {{ pm | json }}
    </div>-->
    <div class="payment-method-error" *ngIf="updatePaymentMethodError">
      {{ updatePaymentMethodError?.message }}
    </div>

    <div class="pad">
      <p class="edit-card__description">
        {{ content?.fields?.resources | findResource: 'settings.paymentMethodUpdateDescription' }}
      </p>
      <div class="card-entry">
        <div id="card" #cardElement></div>
        <div class="input-error">{{ cardError }}</div>
      </div>
      <div class="flex-center">
        <button
          class="update"
          [ngClass]="{ 'update--loading': updatePaymentMethodProcessing }"
          (click)="updatePaymentMethod()"
          [disabled]="!cardComplete || updatePaymentMethodProcessing"
        >
          {{ content?.fields?.resources | findResource: 'settings.paymentMethodUpdateButtonText' }}
        </button>

        <a class="cancel" (click)="editPaymentMethod = false">{{
          content?.fields?.resources | findResource: 'settings.paymentMethodCancelUpdateText'
        }}</a>
      </div>
    </div>
  </div>
</div>
